module.exports = __webpack_public_path__ + "static/img/b85741b73f75806e5d7d146c1ac091ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/首页-改-2_30.jpg
// module id = AJb/
// module chunks = 1